
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("buOGu", function(module, exports) {

$parcel$export(module.exports, "SmartRequestSummaryTrigger", () => $4dc3ccd38a1e62c1$export$248bd4abd6d78930);

var $5uXOq = parcelRequire("5uXOq");

var $d6u6P = parcelRequire("d6u6P");

var $iaqCW = parcelRequire("iaqCW");
const $4dc3ccd38a1e62c1$export$248bd4abd6d78930 = ({ props: { triggerRef: triggerRef, ...props } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6u6P.SummaryStateContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaqCW.Trigger), {
        ...props,
        ref: triggerRef
    }));

});


//# sourceMappingURL=async-issue-smart-request-summary-trigger.0253556b.js.map
